import { recordPageReady } from '@stitch-fix/client-analytics-reporter';
import { Box, ModuleHeader } from '@stitch-fix/mode-react';
import CategoryCard, { CategoryCardProps } from '@stitch-fix/mode-react/CategoryCard';
import { useEffect } from 'react';
import { CategorySetPageFragment } from '../../queries/getCategorySetPageAtBuildTime';
import { BusinessLineRoutes } from '../../utils/routingHelper';
import { formatCategoryCards } from '../CategoryCardsModule/utils';
import Link from '../Link';
import AlphaSortGrid from './AlphaSortGrid';
import styles from './styles.module.scss';
interface Props {
  businessLine: BusinessLineRoutes;
  categorySetPage: CategorySetPageFragment;
}
const formatCategoryCardGridProps = ({
  categorySetPage,
  businessLine
}: {
  categorySetPage: CategorySetPageFragment;
  businessLine: string;
}) => {
  return {
    minColumns: categorySetPage.minimumColumns,
    variant: categorySetPage.cardLayout.toLowerCase() as CategoryCardProps['variant'],
    categories: categorySetPage.categorySet.cards.map(card => formatCategoryCards({
      ...card,
      href: `/${businessLine}/clothing/${categorySetPage.categorySet.id}/${card.category.id}`
    }))
  };
};
const CategorySetPageCategories = ({
  categorySetPage,
  businessLine
}: Props) => {
  const {
    variant,
    categories,
    minColumns
  } = formatCategoryCardGridProps({
    categorySetPage,
    businessLine
  });
  const rumImages = categories
  // Only load the top 6 categories per mobile above the fold
  .slice(0, 6)
  // Load only valid media paths
  .map(({
    image = {}
  }) => 'mediaPath' in image ? image.mediaPath : '');
  useEffect(() => {
    recordPageReady({
      resources: rumImages
    });
  }, [rumImages]);

  // Return empty state if there are no categories
  if (categories.length === 0) {
    return <Box my={3}>
        <ModuleHeader header="Check back again soon" subheader={'We\'re working to curate "so you" collections. P.S. Categories refresh throughout the day.'} />
      </Box>;
  }

  // Return alpha sort grid vs cards grid if layout is set to ALPHA_SORT
  if (categorySetPage?.pageLayout === 'ALPHA_SORT') {
    return <AlphaSortGrid businessLine={businessLine} categorySetPage={categorySetPage} />;
  }
  return <Box data-testid="category-set-page-categories" className={`${styles.grid} ${styles[variant]} ${styles[`min-columns-${minColumns}`]}`}>
      {categories.map(category => <CategoryCard key={category.categoryId} {...category} linkAs={Link} variant={variant} />)}
    </Box>;
};
export default CategorySetPageCategories;